interface Props {
  width?: number | string
  height?: number | string
  viewBox?: string
}

export default function NotFound({ width, height, viewBox }: Props) {
  return (
    <svg width={width} height={height} viewBox={viewBox} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <filter x="-10.9%" y="-9.5%" width="121.8%" height="119.0%" filterUnits="objectBoundingBox" id="filter-1">
          <feGaussianBlur stdDeviation="10" in="SourceGraphic" />
        </filter>
        <path
          d="M8.46268657,18.8059701 L151.910144,18.8059701 L293.640918,9.97676083 C296.931761,9.77175565 299.765706,12.2733216 299.970711,15.5641647 C299.97841,15.6877465 299.982262,15.811538 299.982262,15.9353594 L299.982262,317.404368 C299.982262,320.55761 297.530056,323.167153 294.382902,323.362992 L151.747621,332.238806 L8.46268657,332.238806 C5.16546418,332.238806 2.49253731,329.565879 2.49253731,326.268657 L2.49253731,24.7761194 C2.49253731,21.478897 5.16546418,18.8059701 8.46268657,18.8059701 Z"
          id="path-2"
        />
        <linearGradient x1="113.720234%" y1="-11.6547402%" x2="-128.390217%" y2="215.423448%" id="linearGradient-4">
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#D3DADB" stopOpacity="0.06" offset="100%" />
        </linearGradient>
        <linearGradient x1="100%" y1="41.8656862%" x2="4.00503239%" y2="50%" id="linearGradient-5">
          <stop stopColor="#D8DDDE" stopOpacity="0" offset="0%" />
          <stop stopColor="#D8DDDE" stopOpacity="0.25" offset="100%" />
        </linearGradient>
        <linearGradient x1="96.0449801%" y1="20.5253495%" x2="0%" y2="46.8159473%" id="linearGradient-6">
          <stop stopColor="#DADFE0" stopOpacity="0" offset="0%" />
          <stop stopColor="#20273D" stopOpacity="0.25" offset="100%" />
        </linearGradient>
        <linearGradient x1="100%" y1="44.9203776%" x2="3.08280866%" y2="60.1127513%" id="linearGradient-7">
          <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
          <stop stopColor="#081230" stopOpacity="0.403108016" offset="100%" />
        </linearGradient>
        <polygon id="path-8" points="151.482136 4.95638058 300.735867 4.95638058 300.735867 348.239963 151.482136 348.239963" />
        <filter x="-5.9%" y="-5.9%" width="111.8%" height="111.8%" filterUnits="objectBoundingBox" id="filter-10">
          <feOffset dx="2" dy="0" in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1" />
          <feColorMatrix values="0 0 0 0 0.933333333   0 0 0 0 0.933333333   0 0 0 0 0.933333333  0 0 0 1 0" type="matrix" in="shadowInnerInner1" />
        </filter>
      </defs>
      <g id="020-Main-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="404" transform="translate(-748.000000, -237.000000)">
          <g transform="translate(970.000000, 451.000000) rotate(20.000000) translate(-970.000000, -451.000000) translate(820.000000, 281.000000)">
            <rect
              id="Rectangle-3"
              fill="#D8D8D8"
              opacity="0.400000006"
              filter="url(#filter-1)"
              x="0.683067719"
              y="22.7786451"
              width="275.105345"
              height="316.265713"
            />
            <mask id="mask-3" fill="white">
              <use xlinkHref="#path-2" />
            </mask>
            <use id="Mask" fill="#FFFFFF" xlinkHref="#path-2" />
            <path
              d="M23.3880597,33.7313433 L151.850841,33.7313433 L278.050768,25.4320073 C281.340883,25.2156382 284.183451,27.7074019 284.39982,30.9975173 C284.408396,31.1279316 284.412688,31.2585924 284.412688,31.3892884 L284.412688,274.649419 C284.412688,277.793594 281.974111,280.398899 278.836799,280.606535 L152.691246,288.955224 L23.3880597,288.955224 C20.0908373,288.955224 17.4179104,286.282297 17.4179104,282.985075 L17.4179104,39.7014925 C17.4179104,36.4042702 20.0908373,33.7313433 23.3880597,33.7313433 Z"
              id="Mask"
              fill="url(#linearGradient-4)"
              mask="url(#mask-3)"
            />
            <text
              id="404-copy"
              fill="#D8DDDE"
              mask="url(#mask-3)"
              fontFamily="HelveticaNeue-Bold, Helvetica Neue"
              fontSize="115.087215"
              fontWeight="bold"
            >
              <tspan x="54.7919737" y="199.801193">
                404
              </tspan>
            </text>
            <path
              d="M1.30713393,43.0880865 L-9.80662198,42.9055617 C-10.5765211,42.9055617 -10.9614707,42.6197437 -10.9614707,42.0481077 C-10.9614707,41.4764716 -10.5765211,41.1906536 -9.80662198,41.1906536 L1.19677559,41.0099413 C1.49584354,36.5883919 5.15964655,33.0949327 9.63539096,33.0949327 C14.3067995,33.0949327 18.0937243,36.9005123 18.0937243,41.5949327 C18.0937243,46.2893531 14.3067995,50.0949327 9.63539096,50.0949327 C5.47091268,50.0949327 2.00936967,47.0704833 1.30713393,43.0880865 Z"
              id="Combined-Shape"
              fill="url(#linearGradient-5)"
              mask="url(#mask-3)"
              transform="translate(3.593724, 41.594933) scale(-1, -1) rotate(-55.000000) translate(-3.593724, -41.594933) "
            />
            <g id="Mask" opacity="0.300000012" mask="url(#mask-3)">
              <use fillOpacity="0.5" fill="url(#linearGradient-6)" xlinkHref="#path-8" />
              <use fillOpacity="0.2" fill="url(#linearGradient-7)" xlinkHref="#path-8" />
            </g>
            <g
              id="Group-Copy"
              transform="translate(14.500000, 16.500000) rotate(-77.000000) translate(-14.500000, -16.500000) translate(-0.000000, 8.000000)"
            >
              <g id="Oval-Copy-2">
                <use fill="#F2F2F2" fillRule="evenodd" xlinkHref="#path-9" />
                <use fill="black" fillOpacity="1" filter="url(#filter-10)" xlinkHref="#path-9" />
              </g>
              <ellipse id="Oval-Copy-4" fill="#FFFFFF" opacity="0.800000012" cx="25.375" cy="8.5" rx="2.41666667" ry="2.42857143" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

NotFound.defaultProps = {
  width: 416,
  height: 440,
  viewBox: '0 0 416 440'
}
